<template>
    <a-modal v-model="visible"
        :title="(form.external_id ? '修改' : '新增') + (form.channel == 1 ? '客户余额收付款' : form.channel == 2 ? '额外费用收付款' : form.channel == 3 ? '供应商收付款' : form.channel == 4 ? '现场收款' : '')"
        @ok="handleOk" destroyOnClose @cancel="handleClose" :confirmLoading="confirmLoading" :maskClosable="false"
        width="876px">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-row :gutter="20">
                <a-col :span="12">
                    <a-form-model-item label="类型" required>
                        <a-radio-group v-model="form.pay_type" :disabled="readonly">
                            <!-- :disabled="!!form.external_id" -->
                            <a-radio value="1">
                                收款
                            </a-radio>
                            <a-radio value="2" v-if="form.channel != 4">
                                付款
                            </a-radio>
                        </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item :label="(form.pay_type == '1' ? '收款' : '付款') + '账户'" prop="account_id">
                        <!-- <a-cascader :options="accountList" v-model="form.account_id" placeholder="请选择" /> -->
                        <!-- <el-cascader  :show-all-levels="false" v-model="form.account_id" :options="accountList" :props="{ expandTrigger: 'hover' }"></el-cascader> -->
                        <a-select v-model="form.account_id" show-search :filter-option="filterOption" placeholder="请选择"
                            style="width: 100%" :disabled="readonly">
                            <a-select-option v-for="item in accountList" :key="item.account_id"
                                :value="item.account_id">
                                {{ item.account_name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item :label="(form.pay_type == '1' ? '收款' : '付款') + '名称'" prop="external_name">
                        <!-- <a-input v-model="form.external_name" placeholder="请输入费用名称" :disabled="readonly"></a-input> -->
                        <a-textarea v-model="form.external_name" placeholder="请输入费用名称" :disabled="readonly"
                            auto-size></a-textarea>
                    </a-form-model-item>
                    <a-form-model-item :label="(form.pay_type == '1' ? '收款' : '付款') + '金额'" prop="external_total">
                        <a-input-number v-model="form.external_total" :step="0.01" style="width: 100%"
                            placeholder="请输入金额" :disabled="readonly" />
                        <span v-if="form.channel != 4">提示：支出请写负数，收入请写正数</span>
                    </a-form-model-item>
                    <a-form-model-item label="交易时间" prop="external_receivetime">
                        <a-date-picker show-time style="width: 100%" :format="'YYYY/MM/DD HH:mm:ss'"
                            :valueFormat="'YYYY/MM/DD HH:mm:ss'" v-model="form.external_receivetime"
                            :disabled-date="disabledDate" :disabled="readonly" />
                    </a-form-model-item>
                    <a-form-model-item label="核对状态" prop="process_status"
                        v-permission="['admin:tripexternal:jidiaoExamine']">
                        <!-- 核对状态1待核对2核对通过3核对不通过 -->
                        <a-select v-model="form.process_status" placeholder="是否核对">
                            <a-select-option value="1">待核对</a-select-option>
                            <a-select-option value="2">核对通过</a-select-option>
                            <a-select-option value="3">核对不通过</a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item :label="(form.pay_type == '1' ? '收款' : '付款') + '备注'" prop="receipts_remark">
                        <a-input v-model="form.receipts_remark" placeholder="备注" :disabled="readonly"></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="批量结算项目">
                        <a-tag color="blue" v-for="item in selectedRows" :key="item.tripproject_id">{{ item.project_name
                        }} ｜ 成本：{{ item.cost_total }}元</a-tag>
                    </a-form-model-item>
                    <a-spin :indicator="() => null" :spinning="!form.external_id" tip="新增后可编辑资料">
                        <a-form-model-item :label="(form.pay_type == '1' ? '收款' : '付款') + '资料'">
                            <a-upload-dragger name="file" :multiple="false" :action="baseURL + '/admin/sys/upload'"
                                @change="handleChange" :disabled="readonly">
                                <p class="ant-upload-drag-icon">
                                    <a-icon type="inbox" />
                                </p>
                                <p class="ant-upload-text">
                                    单击或拖动文件到此区域进行上传
                                </p>
                                <p class="ant-upload-hint">
                                    用于留存收款图片或发票文件等
                                </p>
                            </a-upload-dragger>
                        </a-form-model-item>
                        <a-list :locale="{ emptyText: '暂未上传图片或发票文件' }" class="demo-loadmore-list"
                            item-layout="horizontal" :data-source="fileList">
                            <a-list-item slot="renderItem" slot-scope="item, index">
                                <a slot="actions" @click="prewview(item.tripfile_url)"
                                    v-if="checkFileType(item.tripfile_url) == 1">预览</a>
                                <a slot="actions" @click="download(item.tripfile_url)">下载</a>
                                <a slot="actions" @click="del(item.id)" :disabled="readonly">删除</a>
                                <a-list-item-meta :description="item.create_time">
                                    <a slot="title">{{ checkFileType(item.tripfile_url) == 1 ? '图片类型' : '文件类型' }}({{
                                        item.tripfile_url.substr(0, 12) + '...' +
                                        item.tripfile_url.substr(item.tripfile_url.length
                                            - 12, item.tripfile_url.length - 1) }})</a>
                                    <a-avatar slot="avatar"
                                        :style="{ backgroundColor: checkFileType(item.tripfile_url) == 1 ? '#87d068' : '#1890FF' }"
                                        :icon="checkFileType(item.tripfile_url) == 1 ? 'file-image' : 'file'" />
                                </a-list-item-meta>
                            </a-list-item>
                            <!-- checkFileType -->
                        </a-list>
                    </a-spin>
                </a-col>
            </a-row>
        </a-form-model>
    </a-modal>
</template>

<script>
import moment from 'moment'
import { baseURL } from "@/api/index";
import Decimal from "decimal.js";
export default {
    data() {
        return {
            readonly: false,
            baseURL,
            visible: false,
            confirmLoading: false,
            form: {
                trip_id: "",//行程id
                external_id: "", //收付款id
                account_id: undefined, //收款账户
                channel: "1", //收款渠道1客户收付款2利润额外费用（手续费）3对供应商收付款
                pay_type: "1", //收付款类型1收款2付款
                external_name: "",//收付款名称
                external_total: "", //收款金额
                external_remark: "", //收款备注
                external_receivetime: "", //收付款时间
                process_status: '1'
            },
            selectedRows: [],//选中的行
            project_data: [],//项目数据
            accountList: [],
            fileList: [],
            submitLoading: false,
            rules: {
                external_name: {
                    required: true,
                    message: "请输入名称",
                    trigger: "change",
                },
                account_id: {
                    required: true,
                    message: "选择账户",
                    trigger: "change",
                },
                external_total: {
                    required: true,
                    message: "请输入金额",
                    trigger: "change",
                },
                external_receivetime: {
                    required: true,
                    message: "请选择时间",
                    trigger: "change",
                },
                process_status: {
                    required: true,
                    message: "请选择费用核对状态",
                    trigger: "change",
                }
            },
            labelCol: { span: 7 },
            wrapperCol: { span: 15 },
        };
    },
    methods: {
        read({ external_id }) {
            this.init({ external_id })
            this.readonly = true
        },
        init({ external_id, trip_id, channel, pay_type, project_data, selectedRows = [] }) {
            if (!channel && !external_id) {
                return this.$message.error("参数错误")
            }
            if (selectedRows && selectedRows.length > 0) {
                let value = new Decimal(0);
                let names = []
                //已选中的行程
                this.selectedRows = selectedRows
                selectedRows.forEach(row => {
                    value = value.plus(new Decimal(row.cost_total))
                    names.push(row.project_name)
                })
                this.form.external_total = -value.toNumber()
                this.form.external_name = names.join(",")
            }
            if (pay_type) this.form.pay_type = pay_type
            if (project_data) this.form.project_data = project_data
            this.form.external_receivetime = moment().format('YYYY-MM-DD HH:mm:ss')
            this.form.channel = channel
            this.form.external_id = external_id;
            this.form.trip_id = trip_id
            this.visible = true;
            if (external_id) {
                this.getFiles()
                this.$http({
                    url: "/admin/tripexternal/info",
                    method: "post",
                    data: {
                        id: this.form.external_id,
                    },
                }).then(res => {
                    this.form = {
                        ...res.data
                    }
                })
            } else {
                this.form.account_id = localStorage.getItem('trip_account_id') || undefined
            }
            this.$http({
                url: "/admin/account/select",
                method: "get",
            }).then(res => {
                this.accountList = res.data
            })
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        prewview(url) {
            this.$viewerApi({
                images: [url],
            });
        },
        download(url) {
            window.open(url)
        },
        del(id) {
            this.$confirm({
                title: '是否确认删除当前文件资料?',
                content: '删除后将不可恢复',
                okText: '确认删除',
                okType: 'danger',
                onOk: () => {
                    this.$http({
                        url: '/admin/tripfiles/delete',
                        method: 'post',
                        data: { id }
                    }).then(() => {
                        this.$message.success("删除成功, 收款资料已更新")
                        this.getFiles()
                    })
                },

            });
        },
        disabledDate(current) {
            // 禁用今天之后的日期
            return current && current > new Date();
        },
        //获取所有资料
        getFiles() {
            this.$http({
                url: '/admin/tripfiles/getFiles',
                data: {
                    external_id: this.form.external_id
                },
                method: 'post'
            }).then(res => {
                this.fileList = res.data
            })
        },
        remove(e) {
            console.log(e)
        },
        checkFileType(url) {
            const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];

            // 判断 URL 是否以图片扩展名结尾
            if (imageExtensions.some(ext => url.toLowerCase().endsWith(ext))) {
                return 1; // 图片
            }

            return 2; // 文件
        },
        handleChange(info) {
            const status = info.file.status;
            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (status === 'done') {
                // this.$message.success(`${info.file.name} 上传成功`);
                const url = info.file.response.data.url
                this.$http({
                    url: '/admin/tripfiles/uploadTripFile',
                    method: 'post',
                    data: {
                        external_id: this.form.external_id,
                        tripfile_url: url
                    }
                }).then(() => {
                    this.$message.success("上传成功,收款资料已更新")
                    this.getFiles()
                })
                // this.$nextTick(() => {
                //     info.fileList = []
                // })
            } else if (status === 'error') {
                this.$message.error(`${info.file.name} 文件上传失败`);
            }
        },
        handleOk() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.confirmLoading = true;
                    this.$http({
                        url: this.form.external_id ? "/admin/tripexternal/update" : "/admin/tripexternal/create",
                        method: "post",
                        data: {
                            ...this.form,
                            batchids: this.selectedRows.map(item => item.tripproject_id)
                        },
                    })
                        .then(() => {
                            localStorage.setItem('trip_account_id', this.form.account_id)
                            this.$message.success(this.form.external_id ? '修改' : '新增' + '成功');
                            this.handleClose();
                            this.$emit("ok");
                        })
                        .finally(() => (this.confirmLoading = false));
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleClose() {
            this.$refs.ruleForm.resetFields();
            this.fileList = []
            this.selectedRows = []
            this.visible = false;
            this.readonly = false
        },
    },
};
</script>

<style></style>